/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { EnrollPhoneWidgetContext } from './enroll-phone-base';

export class EnrollCallWidgetContext extends EnrollPhoneWidgetContext {
  protected getRequestButtons(): HTMLElement[] {
    return this.elements.getCallRequestButtons();
  }
}
